module.exports = __webpack_public_path__ + "img/referto-2.488752ae.jpg";